import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableLtlVoidedGrid = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableLtlVoidedGrid);
};
